import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { ResourceKey } from "web_myplann/Reminders/Types/ReminderTypes";

export type SnoozeOption = {
	labelKey: ResourceKey;
	days: number;
};

export const SNOOZE_OPTIONS: SnoozeOption[] = [
	{ labelKey: Resources.Reminders.Snooze.tomorrow, days: 1 },
	{ labelKey: Resources.Reminders.Snooze.in3Days, days: 3 },
	{ labelKey: Resources.Reminders.Snooze.in1Week, days: 7 },
	{ labelKey: Resources.Reminders.Snooze.in2Weeks, days: 14 },
];
